import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../services/api";
import "./DynamicPage.css";

import AnalogCard from "../components/dynamic/AnalogCard";
import DigitalCard from "../components/dynamic/DigitalCard";
import IOCard from "../components/dynamic/IOCard";

const DynamicPage = () => {
  const params = useParams();
  const pageKey = params.slug ?? params.id ?? params.pageId ?? params.pk ?? Object.values(params)[0];

  const [page, setPage] = useState(null);
  const [latestMap, setLatestMap] = useState({});
  const [error, setError] = useState("");

  const isNumeric = (v) => /^\d+$/.test(String(v));

  const fetchPage = async () => {
    setError("");
    try {
      if (!pageKey) {
        setError("Route param missing. Check App.js route.");
        return;
      }

      // ✅ ID
      if (isNumeric(pageKey)) {
        const res = await API.get(`/pages/${pageKey}/detail/`);
        setPage(res.data);
        return;
      }

      // ✅ Slug (نیازمند API: /api/pages/slug/<slug>/detail/)
      const res = await API.get(`/pages/slug/${pageKey}/detail/`);
      setPage(res.data);
    } catch (err) {
      console.error("fetchPage error:", err);
      setError("Failed to load page detail.");
    }
  };

  const fetchLatest = async () => {
    try {
      const res = await API.get("/latest-tag-values/");
      const map = {};
      (res.data || []).forEach((x) => {
        map[x.tag_name] = x;
      });
      setLatestMap(map);
    } catch (e) {
      console.error(e);
    }
  };

  // // ✅ Digital write (0/1) -> /api/set-digital-tag/
  // const setDigitalValue = async (tagId, value) => {
  //   await API.post("/set-digital-tag/", { tag_id: tagId, value });
  //   await fetchLatest();
  // };
const setDigitalValue = async (tagId, value) => {
  // ✅ دقیقا مثل IO از همان API استفاده می‌کنیم
  await API.post("/set-tag-value/", { tag_id: tagId, value });
  await fetchLatest();
};
  // ✅ Analog write -> /api/set-tag-value/
  const setAnalogValue = async (tagId, value) => {
    await API.post("/set-tag-value/", { tag_id: tagId, value });
    await fetchLatest();
  };

  useEffect(() => {
    fetchPage();
    fetchLatest();
    const interval = setInterval(fetchLatest, 3000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageKey]);

  const sections = useMemo(() => page?.sections_detail || [], [page]);

  if (error) {
    return (
      <div className="dg-container">
        <h1>Dynamic Page</h1>
        <div className="dg-error">{error}</div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="dg-container">
        <h1>Dynamic Page</h1>
        <div className="dg-muted">Loading...</div>
      </div>
    );
  }

  return (
    <div className="dg-container">
      <h1 className="dg-title">{page.title}</h1>
      {page.description && <p className="dg-subtitle">{page.description}</p>}

      {sections.map((slink) => {
        const section = slink.section;
        const mode = section.mode; // analog | digital | io
        const tags = section.tags_detail?.map((tlink) => tlink.tag) || [];

        return (
          <div className="dg-section" key={slink.id}>
            <div className="dg-section-head">
              <h2>{section.title}</h2>
              <span className="dg-badge">{mode}</span>
            </div>

            {section.description && <div className="dg-section-desc">{section.description}</div>}

            <div className="dg-grid">
              {tags.map((tag) => {
                if (mode === "analog") {
                  return <AnalogCard key={tag.id} tag={tag} latestMap={latestMap} />;
                }
                if (mode === "digital") {
                  return (
                    <DigitalCard
                      key={tag.id}
                      tag={tag}
                      latestMap={latestMap}
                      onSetDigital={setDigitalValue}
                    />
                  );
                }
                return <IOCard key={tag.id} tag={tag} latestMap={latestMap} onSetAnalog={setAnalogValue} />;
              })}

              {tags.length === 0 && <div className="dg-muted">No tags in this section.</div>}
            </div>
          </div>
        );
      })}

      {sections.length === 0 && <div className="dg-muted">This page has no sections yet.</div>}
    </div>
  );
};

export default DynamicPage;